import React from 'react';

import './InsuranceEventSummary.scss';

type Index = 0 | 1 | 2 | 3 | 4 | 5;

interface Props {
  totals: [string, number][];
}

function QuickStatsBox({
  idx,
  title,
  count,
}: {
  idx: Index;
  title: string;
  count: number;
}) {
  return (
    <div className={`quick-stats-box blue${idx}`}>
      <div className="pt-5 f-small foreground">{title}</div>
      <div className="f-bigger pt-5 foreground">{count}</div>
    </div>
  );
}

export function QuickStats({ totals }: Props) {
  return (
    <div>
      <div className="f-medium">Quick Stats</div>
      <div className="flex flex-wrap">
        {totals.map(([name, count], idx) => (
          <QuickStatsBox
            key={name}
            idx={idx as Index}
            title={name}
            count={count}
          />
        ))}
      </div>
    </div>
  );
}
